"use client";

import { useRouter } from "next/navigation";
import React from "react";
import ErrorScreen from "@/components/ErrorScreen";
import { NEXT_PUBLIC_CDN_URL } from "@/libs/constants/auth";
import routes from "@/helpers/router";

const PageNotFound: React.FC = () => {
  const router = useRouter();

  return (
    <div>
      <ErrorScreen
        errorImage={`${NEXT_PUBLIC_CDN_URL}/images/ui_revamp_desktop404.svg`}
        prefixTitle="Oooops!"
        postfixTitle="We’re broken"
        subTitle="Seems like we've lost our way in the medical maze. Stay tuned as we navigate back to the right path."
        ctaText="Go to Home Page"
        onClick={() => router.push(routes.home)}
      />
    </div>
  );
};

export default PageNotFound;
